import React from 'react';
import PropTypes from 'prop-types';
//import styled from 'styled-components';
import { Container } from '../components/Layout';

const Text = ({ input }) => {
  return input && input.primary && input.primary.text ? (
    <Container as="article" restrict>
      <div
        style={{ padding: 'var(--size-space-huge) 0' }}
        dangerouslySetInnerHTML={{ __html: input.primary.text.html }}
      />
    </Container>
  ) : (
    console.log('ALERT: Body Text Error')
  );
};

export default Text;

Text.propTypes = {
  input: PropTypes.object.isRequired,
};
